import React, { useContext, useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel3";

import {
  AuthContextProvider,
  LoaderContext,
} from "../../AuthContext/AuthContext";
import { CurrentBlogData, GetWebAppBlogList } from "../../ApiServices/BlogApi/BlogAPI";
import { Link, useNavigate } from "react-router-dom";
import batuk from "../../assets/images/new/fav-removebg-preview.png";
import { t } from "i18next";

const BlogCarousel = () => {
  const [blogList, setblogList] = useState([]);
  const [showCarousel, setShowCarousel] = useState([]);
  const [totalRecords, setTotalRecords] = useState(-1);
  const { setLoader, selectedLanguageID } = useContext(LoaderContext);

  const navigate = useNavigate();

  const stripHtml = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.innerText || tempDiv.textContent || "";
  };

  const options = {
    loop: blogList.length > 3,
    rewind: true,
    margin: 30,
    nav: true,
    dots: false,
    autoplay: true,
    autoplayTimeout: 3000,
    smartSpeed: 1000,
    lazyLoad: true, // ✅ important for performance
    navText: [
      "<i class='fas fa-arrow-left'></i>",
      "<i class='fas fa-arrow-right'></i>",
    ],
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      1000: {
        items: 4,
      },
    },
  };


  useEffect(() => {
    GetCurrentBlog({
      pageNo: 0,
      pageSize: 10,
      sortingDirection: null,
      sortingColumnName: null,
      searchKeyword: null,
      fromDate: null,
      toDate: null,
    });


    const handleScroll = () => {
      const scrollY = window.scrollY;
      const triggerPoint = 800; // adjust based on layout
      if (scrollY > triggerPoint) {
        setShowCarousel(true);
        window.removeEventListener('scroll', handleScroll); // remove after first trigger
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [selectedLanguageID]);






  const GetCurrentBlog = async (params) => {


    const response = await GetWebAppBlogList(params, null, Number(selectedLanguageID));

    if (response?.statusCode === 200) {
      const blogs = response?.responseData?.data || [];

      const updated = blogs.filter((item) => item && item.blogImage); // Ensure no empty items
      setblogList(updated);
      setTotalRecords(updated?.length)

    } else {
      setTotalRecords(0)
    }



  };

  const handleNavigation = (slug) => {
    navigate(`/spiritual-gyan/${slug}`, { replace: true });
    window.scrollTo({ top: 0, behavior: "instant" }); // Instantly move to the top without scroll animation

  };
  return (
    <section
      data-aos="zoom-in"
      data-aos-duration="1000"
      className="blog-section p-2"
      style={{ marginBottom: "50px", backgroundColor: "#ffffffff" }}
    >
      <div
        className="container"
        style={{ display: "flex", flexDirection: "column", cursor: "pointer" }}
      >
        <div className="row">
          <div className="col-12">
            <div className="section-title text-center">
              <h6
                className="sec-title__tagline bw-split-in-right"
                style={{
                  perspective: "400px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img className="tagline-img" src={batuk} alt="" />
                {t("Trending Posts")}
              </h6>
              <h3
                className="sec-title__title bw-split-in-left"
                style={{ perspective: "400px", textAlign: "center" }}
              >
                {t("Spiritual Insights & Wisdom")}
              </h3>
            </div>

            <OwlCarousel className="owl-theme" {...options}>
              {blogList && blogList.length > 0 ? (
                blogList.map((item, index) =>
                  item && item.blogImage ? (
                    <div key={item.ROW || index} onClick={() => handleNavigation(item.blogSlug)}>
                      <div
                        className="card-custom"
                        style={{ height: "400px" }}
                      >
                        <div className="card-custom__header">
                          <img
                            src={item.blogImage}
                            alt={item.blogTitle}
                            style={{ objectFit: "fill" }}
                            className="card-custom__image"
                          />
                        </div>
                        <div className="card-custom__body">
                          <h4 className="service-two__item__title">
                            {item.blogTitle}
                          </h4>
                          <p className="card-text text-muted small">
                            {stripHtml(item.blog).length > 50
                              ? `${stripHtml(item.blog).substring(0, 50)}...`
                              : stripHtml(item.blog)}
                          </p>
                        </div>
                        <div
                          className="service-two__item__rm"
                          onClick={() => handleNavigation(item.blogSlug)}
                        >
                          <span style={{ color: "#a52444" }}>{t("Read More")}</span>
                          <i className="icon-right-arrow"></i>
                        </div>
                      </div>
                    </div>
                  ) : null
                )
              ) : totalRecords < 0 ? (
                <p className="text-center d-flex justify-content-center fw-bold">{t("Loading...")}</p>
              ) : (<p className="text-center d-flex justify-content-center fw-bold">{t("No blogs available")}</p>)}
            </OwlCarousel>

            {/* ✅ View More Button */}
            <div
              className="text-center mt-4"

              data-aos-duration="800"
            >
              <button
                className="careox-btn"
                style={{
                  backgroundColor: "#a52444",
                  color: "#fff",
                  padding: "10px 25px",
                  borderRadius: "30px",
                  border: "none",
                  fontWeight: "600",
                  transition: "all 0.3s ease",
                  marginTop: "-61px"
                }}
                onMouseOver={(e) => (e.target.style.backgroundColor = "#831b34")}
                onMouseOut={(e) => (e.target.style.backgroundColor = "#a52444")}
                onClick={() => navigate("/spiritual-gyan")} // 👈 redirect to your blog page
              >
                {t("View More")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

  );
};

export default BlogCarousel;